import { render, staticRenderFns } from "./trouble-update.vue?vue&type=template&id=5a818876"
import script from "./trouble-update.vue?vue&type=script&lang=js"
export * from "./trouble-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports